import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FormInput, FormSelect } from "@/components/form";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { TOBACCO_MULTIPLIERS, TOBACCO_OPTIONS } from "./field-constants";
/** Smoking pack-year calculator: (per-day × type-factor / 20) × years. */
export function SmokingCalculatorField(_ref) {
  var _field$observation;
  var field = _ref.field,
    value = _ref.value,
    disabled = _ref.disabled,
    onChange = _ref.onChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(""),
    qty = _useState[0],
    setQty = _useState[1];
  var _useState2 = useState("Cigarettes"),
    type = _useState2[0],
    setType = _useState2[1];
  var _useState3 = useState(""),
    years = _useState3[0],
    setYears = _useState3[1];
  var packYears = String(value !== null && value !== void 0 ? value : "");
  var recompute = function recompute(nextQty, nextType, nextYears) {
    var _TOBACCO_MULTIPLIERS$;
    if (!nextQty || !nextYears) return;
    var multiplier = (_TOBACCO_MULTIPLIERS$ = TOBACCO_MULTIPLIERS[nextType]) !== null && _TOBACCO_MULTIPLIERS$ !== void 0 ? _TOBACCO_MULTIPLIERS$ : 1;
    onChange((Number(nextQty) * multiplier / 20 * Number(nextYears)).toFixed(2));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start justify-between gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col text-left"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-strong text-sds-base-default"
  }, t((_field$observation = field.observation) !== null && _field$observation !== void 0 ? _field$observation : "")), /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-small text-sds-base-secondary"
  }, t("smoking_calculator.sub_label", {
    defaultValue: "Estimate pack-years"
  }))), packYears ? /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-strong text-sds-base-default"
  }, packYears, " ", t("pack_years", {
    defaultValue: "pack-years"
  })) : null), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap items-end gap-3"
  }, /*#__PURE__*/React.createElement(FormInput, {
    type: "number",
    inputMode: "numeric",
    className: "w-24",
    label: t("unit.cigarettes_day", {
      defaultValue: "Per day"
    }),
    value: qty,
    disabled: disabled,
    onChange: function onChange(event) {
      setQty(event.currentTarget.value);
      recompute(event.currentTarget.value, type, years);
    },
    onBlur: function onBlur() {
      return trackEvent(ANALYTICS_EVENTS.SMOKING_QTY, {
        fieldId: field.id
      });
    },
    "data-testid": "smoking-qty-".concat(field.id)
  }), /*#__PURE__*/React.createElement(FormSelect, {
    className: "w-44",
    data: TOBACCO_OPTIONS,
    value: type,
    disabled: disabled,
    withinPortal: true,
    onChange: function onChange(next) {
      trackEvent(ANALYTICS_EVENTS.SMOKING_TYPE, {
        fieldId: field.id
      });
      var resolved = next !== null && next !== void 0 ? next : "Cigarettes";
      setType(resolved);
      recompute(qty, resolved, years);
    },
    "data-testid": "smoking-type-".concat(field.id)
  }), /*#__PURE__*/React.createElement(FormInput, {
    type: "number",
    inputMode: "numeric",
    className: "w-24",
    label: t("unit.years", {
      defaultValue: "Years"
    }),
    value: years,
    disabled: disabled,
    onChange: function onChange(event) {
      setYears(event.currentTarget.value);
      recompute(qty, type, event.currentTarget.value);
    },
    onBlur: function onBlur() {
      return trackEvent(ANALYTICS_EVENTS.SMOKING_YEARS, {
        fieldId: field.id
      });
    },
    "data-testid": "smoking-years-".concat(field.id)
  })));
}